import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EChannel } from '../../../../shared/models/standard-transcript-normalized.model';
import { IAceParagraph } from '../../../../shared/interfaces/ace-transcript.interface';
import { NgClass } from '@angular/common';

@Component({
  selector: 'cv-ace-transcript',
  standalone: true,
  templateUrl: './ace-transcript.component.html',
  styleUrl: './ace-transcript.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
})
export class AceTranscriptComponent {
  @Input() paragraphs: IAceParagraph[] = [];
  @Input({ required: true }) userName!: string | null;
  @Input({ required: true }) agentName!: string;
  EChannel = EChannel;
}
